import {
  downloadBonusGroupImports,
  downloadExport,
  exportAllDelivery,
  exportAllTrace,
  exportDelivery,
  exportDeliveryPoints,
  exportTrace,
  getDeliveryPointsMatrices,
} from "./query/exportDelivery";

export type {DeliveryPointsMatricesResultBase} from "./query/exportDelivery";

export const deliveryExportClient = {
  query: {
    exportDelivery: exportDelivery,
    exportTrace: exportTrace,
    exportAllDelivery: exportAllDelivery,
    exportAllTrace: exportAllTrace,
    exportDeliveryPoints: exportDeliveryPoints,
    getDeliveryPointsMatrices: getDeliveryPointsMatrices,
    downloadExport: downloadExport,
    downloadBonusGroupImports: downloadBonusGroupImports,
  },
};
